async function setTableOrder({ commit, dispatch }, order) {
  commit('orders/SET_ORDER', order, { root: true });

  const updateParamsPayload = { orderId: order.orderId };

  dispatch('session/updateRouteParamsDirectly', updateParamsPayload, { root: true });

  dispatch('socket/joinOrderRoomConditionally', null, { root: true });

  dispatch('orders/cacheOrderSelection', order, { root: true });

  await dispatch('orders/loadStagedOrderItems', {}, { root: true });
}

export { setTableOrder };
